import { Title, Grid, Item, ItemLogo } from './styles';
import Section from '../../shared/Section';
import SectionHeader from '../../shared/SectionHeader';
import MarginWrapper from '../../shared/MarginWrapper';
import Card from '../../shared/Card';
import techSkills from '../../data/techSkills';

const Skills = () => {
  return (
    <Section id="skills">
      <SectionHeader>Skills</SectionHeader>
      <MarginWrapper>
        {techSkills.map((t) => (
          <Card key={t.name} borderLeft>
            <Title uppercase>{t.name}</Title>
            <Grid>
              {t.items.map((i) => (
                <Item key={i.title}>
                  <ItemLogo>{i.icon}</ItemLogo>
                  <p>{i.title}</p>
                </Item>
              ))}
            </Grid>
          </Card>
        ))}
      </MarginWrapper>
    </Section>
  );
};

export default Skills;
